<template>
  <div class="flex flex-col gap-y-3 overflow-y-auto pr-2">
    <ul class="flex gap-x-3 items-center">
      <strong>{{ state.model?.number }}</strong>
    </ul>
    <ul class="flex gap-x-5">
      <c_cell title="所属甲方">
        <template #default>
          <div class="flex gap-x-2">
            <text>{{ state.model?.customer?.name }}</text>
            <text class="text-gray-400">
              {{ state.model?.customer?.number }}
            </text>
          </div>
        </template>
      </c_cell>
    </ul>
    <c_cell title="款项说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <div
          class="flex flex-wrap gap-x-5 gap-y-2"
          v-if="state.model?.attachment?.length > 0"
        >
          <text
            v-for="file in state.model?.attachment"
            :key="item"
            class="hover:underline cursor-pointer text-green-700"
            @click="$openFile(file.file_url)"
          >
            {{ file.filename }}
          </text>
        </div>
        <text v-else>-</text>
      </template>
    </c_cell>
    <div class="bg-gray-100 flex gap-x-3 py-2.5 px-5 rounded-lg">
      <li class="flex-1 font-bold">收款记录</li>
      <c_cell title="总额">
        <template #default>
          <c_money
            :key="state.model?.amount"
            :value="state.model?.amount"
            :prefix="false"
            bold
          />
        </template>
      </c_cell>
      <c_cell title="已收">
        <template #default>
          <c_money
            :key="state.model?.collected_amount"
            :value="state.model?.collected_amount"
            :prefix="false"
            color="#080"
          />
        </template>
      </c_cell>
      <c_cell title="欠款">
        <template #default>
          <c_money
            :key="state.model?.uncollected_amount"
            :value="state.model?.uncollected_amount"
            :prefix="false"
            color="#ffa500"
          />
        </template>
      </c_cell>
    </div>
    <div
      v-for="(item, index) in state.meetingCollectedRecordList"
      :key="item.id"
      class="px-2.5 flex flex-col gap-y-2.5"
      :class="index != 0 ? 'mt-2.5 pt-2.5 border-t' : ''"
    >
      <ul class="flex gap-x-3 items-center">
        <text>{{ item.number }}</text>
        <text>{{ item.add_admin_name }}</text>
        <text style="margin-left: -5px" class="text-xs text-gray-400">{{
          item.add_department_name
        }}</text>
        <li class="flex-1 text-xs text-gray-400">{{ item.create_time }}</li>
        <c_cell title="收款方式" :value="item.d_collect_type_name" />
        <c_cell title="收款金额">
          <template #default>
            <c_money
              :key="item.amount"
              :value="item.amount"
              :prefix="false"
              bold
            />
          </template>
        </c_cell>
      </ul>
      <c_cell title="收款说明" :value="item.intro" />
      <ul class="flex flex-wrap gap-x-3 gap-y-2" v-if="item.dkkhmc">
        <c_cell
          title="关联到款"
          :value="item.dkkhmc + ' [' + item.dkkhbm + ']'"
        />
        <c_cell title="到款金额">
          <template #default>
            <c_money :value="item.djke" :prefix="false" color="#ffa500" />
          </template>
        </c_cell>
        <c_cell title="认领金额">
          <template #default>
            <c_money :value="item.rlje" :prefix="false" color="#ffa500" bold />
          </template>
        </c_cell>
      </ul>
      <c_cell title="附件">
        <template #default>
          <div class="flex flex-wrap gap-2" v-if="item.attachment?.length > 0">
            <text
              v-for="file in item.attachment"
              :key="item"
              class="hover:underline cursor-pointer text-green-700"
              @click="$openFile(file.file_url)"
            >
              {{ file.filename }}
            </text>
          </div>
          <text v-else>-</text>
        </template>
      </c_cell>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { collectedplan_search } from "@/http/zhangdanshoukuan";
import { ElMessage, ElMessageBox } from "element-plus";
import { attachment_upload } from "@/http/attachment";
import { post_response } from "@/utils/funcs";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
      list_data: [],
      check: {
        files: [],
      },
    });
    onMounted(() => {
      if (props.id) {
        collectedplan_search(props.id).then((res) => {
          if (res.status == 200) {
            const { meetingCollectedPlan, meetingCollectedRecordList } =
              res.data?.data || {};
            state.model = meetingCollectedPlan;
            state.meetingCollectedRecordList = meetingCollectedRecordList;
          }
        });
      }
    });

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.check.files = [...state.check.files, ...res.data.data];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          ElMessageBox.confirm(
            `您确定<strong style="color: #080">支付</strong>吗？`,
            "付款",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              dangerouslyUseHTMLString: true,
              cancelButtonClass: "is-plain",
            },
          ).then(() => {
            meetingpurchasepaymentapply_pay({
              id: props.id,
              transaction_remark: state.check.remark,
              transaction_attachment: JSON.stringify(
                state.check?.files?.map((m) => m.id),
              ),
            }).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          });
        }
      });
    };
    return { state, formDom, onFileChange, onSubmit };
  },
};
</script>
<style scoped></style>
